import { render, staticRenderFns } from "./Saldos.vue?vue&type=template&id=622e9b92&scoped=true&"
import script from "./Saldos.vue?vue&type=script&lang=js&"
export * from "./Saldos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622e9b92",
  null
  
)

export default component.exports